import moment from 'moment'

import $store from '@/store'
import Mustache from 'mustache'
import ChannelModel from './channel.js'
import InstanceModel from './instance.js'
import CacheModel from './cache.js'
import EventExternal from './event_external.js'
import datelib from '../lib/date.js'

export default {
	title_render_obj(event) {
		return {
			event: event,
			get_sport () {
				return (text, render) => {
					return (EventExternal.sport_by_id(render(text))||{}).label;
				}
			},
			get_series () {
				return (text, render) => {
					return (EventExternal.serie_by_id(render(text))||{}).name;
				}
			},
			get_lang () {
				return (text, render) => {
					var default_lang = /{{default:([A-Za-z0-9_.]+)}}/.exec(text);
					var field = /{{field:([A-Za-z0-9_.]+)}}/.exec(text);
					if(!default_lang || !field) {
						return "-";
					} else {
						var data = _.get(event, field[1]);
            if (typeof(data) == "undefined") return "";
						var res = _.find(data, (item) => { return item.lang == default_lang; });
						if (!res) return data[0].value;
						return res.value;
					}
				}
			}
		}
	},

  subtitle_cb (event, default_text, cb) {
    var self = this;
    var form = this.event_form(event);
    if(typeof(form) == "undefined" || typeof(form.value) == "undefined" || typeof(form.value.title_format) == "undefined") cb(default_text||"-");
    cb(self.subtitle(event, default_text));
  },

	title (event, default_text) {
		var form = this.event_form(event);
		if(typeof(form) == "undefined" || typeof(form.value) == "undefined" || typeof(form.value.title_format) == "undefined") return default_text||"-";
		return Mustache.render(form.value.title_format, this.title_render_obj(event));
	},
	subtitle(event, default_text) {
		var form = this.event_form(event);
		if(typeof(form) == "undefined" || typeof(form.value) == "undefined" || typeof(form.value.subtitle_format) == "undefined") return default_text||"-";
		return Mustache.render(form.value.subtitle_format, this.title_render_obj(event));
	},
  formatted_date (event) {
    return datelib.format_date(event.cached_start_time);
  },
  formatted_time (event) {
    return datelib.format_time(event.cached_start_time);
  },
  formatted_date_time (event) {
    return this.formatted_date(event) + " - " + this.formatted_time(event);
  },
	duration (event) {
  	return event.cached_end_time - event.cached_start_time;
  },
  duration_text (event) {
    return moment.duration(this.duration(event), "seconds").format("h [h] m [m]")
  },

  get_timestamp () {
    if ($store.state.timestamp == 0) return Math.floor(Date.now() / 1000);
    return $store.state.timestamp;
  },

  is_current (event, ts) {
		if (typeof(ts) == "undefined") ts = this.get_timestamp();
  	if (ts > event.cached_start_time && ts < event.cached_end_time) return true;
    return false;
  },
  is_near_to_end (event, ts) {
  	if (typeof(ts) == "undefined") ts = this.get_timestamp();
		if (ts > event.cached_start_time && ts < event.cached_end_time) {
			var time_left = event.cached_end_time - ts;
			if (time_left > 1200) return false; // No other checks if long time left

			var duration = event.cached_end_time - event.cached_start_time;
			if (duration > 5400 && time_left < 1200) return true; // Over 1,5h events (20 min)
			if (duration >= 1800 && time_left < 600) return true;	// Between 0,5-1,5h events (10 min)
			if (time_left < duration/5) return true;	// Under 0,5h events (20%)
		}
		return false;
	},
	is_past (event, ts) {
		if (typeof(ts) == "undefined") ts = this.get_timestamp();
    if (ts > event.cached_end_time) return true;
    return false;
  },
  is_future (event, ts) {
		if (typeof(ts) == "undefined") ts = this.get_timestamp();
		if (ts < event.cached_start_time) return true;
      return false;
  },
  progress_percent(event, ts) {
		if (typeof(ts) == "undefined") ts = this.get_timestamp();
		if (this.is_past(event, ts)) return 100;
		if(this.is_current(event, ts)) {
			var result = Math.min(100, ((ts - event.cached_start_time) / (event.cached_end_time - event.cached_start_time) * 100).toFixed(2));
			return (result < 0 ? 0 : result);
		}
		return 0;
  },
  has_source_channel (event) {
    return event.event_group.channel_id != null;
  },
  is_todo_list (event, account) {
    var email = account.email;
    if (typeof(email) != "undefined") {
      return _.get(event.event_group, ["system_meta", "todos", email, "active"], false);
    }
    return false;
  },
  todo_list_status (event, account) {
		var email = account.email;
		if (typeof(email) != "undefined") {
			return _.get(event.event_group, ["system_meta", "todos", email, "status"], undefined);
		}
		return undefined;
  },
  output_channel (event) {
  	return $store.state.channels[event.channel_id];
  },
	event_form (event) {
		var channel = this.output_channel(event);
		if(!channel || !channel.meta) return undefined;
		return ChannelModel.event_form(channel);
	},
  input_channel (event) {
    if (typeof(event.event_group) != "undefined") {
      return $store.state.channels[event.event_group.channel_id];
    } else {
      console.log("ERROR IN EVENT", event);
    }
  },
	alternative(event) {
		var eg = event.event_group;
		if (typeof(eg) != "undefined") {
			return _.get(eg, "system_meta.alternative", "");
		}
		return "";
	},
  instance (event, channel) {
  	return ChannelModel.instance(channel, event);
  },
  input_instance (event) {
  	var channel = this.input_channel(event);
  	return this.instance(event, channel);
  },
	output_instance (event) {
		var channel = this.output_channel(event);
		return this.instance(event, channel);
  },
 	preview_url (event) {
  	var channel = this.output_channel(event);
    if(!channel || channel.type != "output") return '';
    var url = channel.meta.monitor_url || '';
    return this.render_url(url, event, channel);
  },
  live_url (event) {
  	var channel = this.output_channel(event);
  	if(!channel || channel.type != "output") return '';
  	var url = channel.meta.play_url || '';
  	return this.render_url(url, event, channel);
  },
	page_url (event) {
		var channel = this.output_channel(event);
		if(!channel || channel.type != "output") return '';
		var url = channel.meta.page_url || '';
		return this.render_url(url, event, channel);
	},
  render_url (url, event, channel) {
  	return Mustache.render(url, {event: event, event_group: event.event_group, output_channel: channel, input_channel: this.input_channel(event), instance: this.output_instance(event)});
  },
	start_mediaconnects(event, success, fail) {
		$store.dispatch("send_control", {"type": "mediaconnect", "payload": {"type": "start", "event": event.uuid}}).then((msg) => {
			success(msg);
		}).catch((msg) => {
			fail(msg);
		});
	},
	start_transcoder (event, success, fail) {
    $store.dispatch("send_control", {"type": "transcoder", "payload": {"type": "start", "event": event.uuid}}).then((msg) => {
			success(msg)
    }).catch((msg) => {
    	fail(msg);
    });
  },
	stop_mediaconnects (event, success, fail) {
		var r = confirm("Stop mediaconnects?")
		if (r == true) {
			$store.dispatch("send_control", {"type": "mediaconnect", "payload": {"type": "stop", "event": event.uuid}}).then((msg) => {
				success(msg);
			}).catch((msg) => {
				fail(msg);
			});
		}
	},
	stop_transcoder (event, success, fail, message) {
		if (typeof(message) == "undefined") message = "Stop transcoder?"
    var r = confirm(message);
    if (r == true) {
			$store.dispatch("send_control", {"type": "transcoder", "payload": {"type": "stop", "event": event.uuid}}).then((msg) => {
				success(msg)
			}).catch((msg) => {
      	fail(msg);
			});
    }
  },
  link_transcoder (instance, event, success, fail) {
  	if (typeof(event) != "string") {
  		event = event.uuid;
  	}
  	$store.dispatch("send_control", {"type": "transcoder", "payload": {"type": "link", "event": event, "instance": instance.id}}).then((msg) => {
			success(msg)
		}).catch((msg) => {
			fail(msg);
		});
  },
	router_stop_source (event, success, fail) {
		$store.dispatch("send_control", {"type": "router", "payload": {"type": "stop_source", "event": event.uuid}}).then((msg) => {
			success(msg);
    	console.log("Source stopped", msg);
    }).catch((msg) => {
    	fail(msg);
    	console.log("Source stop failed", msg);
    });
	},
	router_stop_destination (event, success, fail) {
   	$store.dispatch("send_control", {"type": "router", "payload": {"type": "stop_destination", "event": event.uuid}}).then((msg) => {
    	success(msg)
    	console.log("Destination stopped", msg);
    }).catch((msg) => {
    	fail(msg);
    	console.log("Destination stop failed", msg);
    });
	},
	render_channel_configuration(event, channel_id) {
		var ch = null;
		if (typeof(channel_id) != "undefined") {
			ch = ChannelModel.get_channel(channel_id);
		} else {
			ch = this.output_channel(event);
		}
		var configuration = _.get(ch, "configuration", {});
		var str_config = JSON.stringify(configuration);
		str_config = Mustache.render(str_config, {event: event});
		return JSON.parse(str_config);
	},
	toggle_multiview(event) {
		if (!$store.state.account) return;
		var acc = _.cloneDeep($store.state.account);
		acc.meta.multiview_event_filter = _.xor(acc.meta.multiview_event_filter, [event.uuid]);
		$store.dispatch("update_profile", acc);
		return _.includes(acc.meta.multiview_event_filter, event.uuid);
	},
	is_multiview(event) {
		if (!$store.state.account) return false;
		var acc = $store.state.account;
		return _.includes(acc.meta.multiview_event_filter, event.uuid);
	},
  languages () {
  	return ["fi", "en", "fr", "es", "ru", "ee"];
  },
  before_times () {
  	return [
			{
				"label": "0 Min",
				"value": 0
			},
			{
				"label": "1 Min",
				"value": -60
			},
			{
				"label": "5 Min",
				"value": -300
			},
			{
				"label": "10 Min",
				"value": -600
			},
			{
				"label": "15 Min",
				"value": -900
			},
			{
				"label": "20 Min",
				"value": -1200
			},
			{
				"label": "25 Min",
				"value": -1500
			},
			{
				"label": "30 Min",
				"value": -1800
			},
			{
				"label": "45 Min",
				"value": -2700
			},
			{
				"label": "1 Hr 0 Min",
				"value": -3600
			},
			{
				"label": "1 Hr 15 Min",
				"value": -4500
			},
			{
				"label": "1 Hr 30 Min",
				"value": -5400
			},
			{
				"label": "1 Hr 45 Min",
				"value": -6300
			},
			{
				"label": "2 Hrs 0 Min",
				"value": -7200
			},
			{
				"label": "2 Hrs 15 Min",
				"value": -8100
			},
			{
				"label": "2 Hrs 30 Min",
				"value": -9000
			},
			{
				"label": "2 Hrs 45 Min",
				"value": -9900
			},
			{
				"label": "3 Hrs 0 Min",
				"value": -10800
			},
			{
				"label": "3 Hrs 15 Min",
				"value": -11700
			},
			{
				"label": "3 Hrs 30 Min",
				"value": -12600
			},
			{
				"label": "3 Hrs 45 Min",
				"value": -13500
			},
			{
				"label": "4 Hrs 0 Min",
				"value": -14400
			},
			{
				"label": "4 Hrs 15 Min",
				"value": -15300
			},
			{
				"label": "4 Hrs 30 Min",
				"value": -16200
			},
			{
				"label": "4 Hrs 45 Min",
				"value": -17100
			},
			{
				"label": "5 Hrs 0 Min",
				"value": -18000
			},
			{
				"label": "5 Hrs 15 Min",
				"value": -18900
			},
			{
				"label": "5 Hrs 30 Min",
				"value": -19800
			},
			{
				"label": "5 Hrs 45 Min",
				"value": -20700
			},
			{
				"label": "6 Hrs 0 Min",
				"value": -21600
			}
		];
  },
	sanoma_content_owner_list_id(data) {
		var account = $store.state.account;
		if(!account) return undefined;
		return _.get(account, "meta.export.sanoma_content_owner_list_id");
	},
	exec_content_id_get_fun(fun, data) {
		var functions = {
			"sanoma_content_owner_list_id": this.sanoma_content_owner_list_id
		}
		if(typeof(functions[fun]) == "function") {
			return functions[fun](data);
		}
		return undefined;
	},
	exec_from_get_fun(fun, data, key) {
		var functions = {
			serie_by_id: EventExternal.serie_by_id,
			sport_by_id: EventExternal.sport_by_id
		}
		if(typeof(functions[fun]) == "function") {
			return (functions[fun](data)||{})[key];
		}
		return undefined;
	}


}
